import makePartsAndShipmentsApiRequest from '../utils/partsAndShipmentsApi';
import { PartV1 } from './types.d';
import { error } from '../legacy/flash-messenger';

interface PartsApiResponse {
  metadata: {
    total: number;
    per_page: number;
    pages: number;
    page: number;
  };
  results: PartV1[];
}

export const createPartApi = async (
  workOrderId: number,
  workOrderUserRole: string,
  companyId: number,
  statusId: number,
  partData: PartV1,
): Promise<PartV1 | undefined> => {
  const payload = {
    parts: [partData],
  };
  try {
    const response = await makePartsAndShipmentsApiRequest<PartsApiResponse>({
      method: 'POST',
      url: `/v2/workorders/${workOrderId}/parts`,
      data: JSON.stringify(payload),
      params: {
        status_id: statusId,
      },
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });

    return response.results[0];
  } catch (err) {
    error((err as Error).message || 'Failed to create part, please try again later.');
    throw err;
  }
};

export const updatePartApi = async (
  workOrderId: number,
  partId: number,
  workOrderUserRole: string,
  companyId: number,
  statusId: number,
  partData: PartV1,
): Promise<PartV1 | undefined> => {
  try {
    const response = await makePartsAndShipmentsApiRequest<PartsApiResponse>({
      method: 'PUT',
      url: `/v2/workorders/${workOrderId}/parts/${partId}`,
      data: JSON.stringify(partData),
      params: {
        status_id: statusId,
      },
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });

    return response.results?.find((part: PartV1) => part.id === partId);
  } catch (err) {
    error((err as Error).message || 'Failed to update part, please try again later.');
    throw err;
  }
};

export const checkExternalIdUniqueness = async (
  externalId: string,
  companyId: number,
  workOrderUserRole: string,
): Promise<boolean> => {
  try {
    const response = await makePartsAndShipmentsApiRequest<{ exists: boolean }>({
      method: 'GET',
      url: `/v2/parts/external-ids/${externalId}`,
      headers: {
        'X-User-Role': workOrderUserRole,
        'X-Company-Id': companyId,
      },
    });
    return !response?.exists;
  } catch (err) {
    error((err as Error).message || 'Failed to validate External ID, please try again later.');
    throw err;
  }
};
